import React from 'react'
import {Icon} from 'common/Icon'
import styles from './AccountTypeBadge.scss'
import cx from 'classnames'

export const AccountTypeBadge = ({accountLevel, className, ...props}) => {
  if (accountLevel === 1) {
    return <Icon i='icon-basic'
      data-tip
      title='Basic Subscriber'
      className={cx(styles.basic, className)}
      {...props} />
  } else if (accountLevel >= 2) {
    return <Icon i='icon-premium'
      data-tip
      title='Premium Subscriber'
      className={cx(styles.premium, className)}
      {...props} />
  } else {
    return null
  }
}
